import { Card, Header } from '@breward/ui';
import DOMPurify from 'dompurify';
import { BeerGuidelines } from '../types';
import { DescriptorBadge } from './DescriptorBadge';
import { JudgeGuidelines } from './JudgeGuidelines';

interface SensoryCardProps {
    id: string;
    title: string;
    icon: string;
    highlight?: string;
    bodyText?: string;
    guidelinesSectionKey?: string;
    gl?: BeerGuidelines;
    schemaData?: any;
}

export const SensoryCard = ({
    id,
    title,
    icon,
    highlight,
    bodyText,
    guidelinesSectionKey,
    gl,
    schemaData,
}: SensoryCardProps) => {
    const renderAromaBadges = (aromaSection: any) => {
        const descriptorValues: string[] = [];
        aromaSection.subsections?.forEach((sub: any) => {
            sub.rules?.forEach((rule: any) => {
                if (rule.ruleType === 'inclusion' && rule.settings?.values) {
                    descriptorValues.push(...rule.settings.values);
                }
            });
        });

        if (descriptorValues.length === 0) return null;
        const uniqueDescriptors = Array.from(new Set(descriptorValues));

        return (
            <div className="flex flex-wrap gap-1.5 pt-1">
                {uniqueDescriptors.map((val, idx) => (
                    <DescriptorBadge key={idx} value={val} />
                ))}
            </div>
        );
    };

    const guidSectionData = guidelinesSectionKey && gl ? gl.sections?.find(s => s.key === guidelinesSectionKey) : null;

    if (!highlight && !bodyText && !guidSectionData) return null;

    return (
        <Card id={`section-${id}`} className="scroll-mt-20">
            <div className="col-span-12 flex flex-col gap-4">
                <Header
                    variant="card"
                    title={title}
                    icon={<div className={icon} />}
                />

                {highlight && (
                    <blockquote className="border-l-4 border-amber-500 pl-4 italic text-sm font-medium text-amber-700 dark:text-amber-400 my-2">
                        &bdquo;{highlight}&rdquo;
                    </blockquote>
                )}

                {bodyText && (
                    <div
                        className="style-description text-primary-800 dark:text-primary-100 font-sans text-sm leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(bodyText) }}
                    />
                )}

                {id === 'aroma' && guidSectionData && renderAromaBadges(guidSectionData)}

                {guidelinesSectionKey && gl && schemaData && (
                    <JudgeGuidelines
                        guidelinesSectionKey={guidelinesSectionKey}
                        gl={gl}
                        schemaData={schemaData}
                    />
                )}
            </div>
        </Card>
    );
};
